import { UPDATE_FILE_DETAILS } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_FILE_DETAILS.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FILE_DETAILS.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_FILE_DETAILS.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
